export const EXTRA_FIELD_VALUES_FIELD = "extraFieldValues";

/**
 * The Others section is one form field. Identify it by this name.
 * Production minification renames ExtraFieldsSection, so function.name
 * is not stable between the dev server and a deployed build.
 */
export const isExtraFieldsFormField = (field) =>
  field?.name === EXTRA_FIELD_VALUES_FIELD;

export const normalizeExtraFieldValuesFromApi = (raw) => {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return {};
  if (raw instanceof Map) return Object.fromEntries(raw.entries());
  return { ...raw };
};
